import { useBackNavigation } from "../utils/backNavigation";

/**
 * The Back button (Administration Part 1 §12). The behaviour lives in `useBackNavigation`; this is
 * the standard control that renders it, so every Administration page gets the same Back.
 *
 * `fallbackTo` is REQUIRED — a page that cannot name its parent cannot honour a deep link, and
 * silently defaulting to "/" is the "every Back goes to Overview" behaviour §12 bans. It is used
 * ONLY when there is no in-app history to step back through.
 */
export default function BackLink({ fallbackTo, label = "Back", className = "btn btn-outline-secondary btn-sm" }) {
  const goBack = useBackNavigation(fallbackTo);

  return (
    <button type="button" className={className} onClick={goBack}>
      <i className="bi bi-arrow-left me-1" />
      {label}
    </button>
  );
}
